var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72 8.64C4.704 8.544 4.704 8.464 4.704 8.432C4.704 7.808 4.976 7.28 5.504 6.912L6.192 6.432C7.12 5.776 7.792 4.88 7.792 3.616C7.792 1.984 6.512 0.415999 4.144 0.415999C1.728 0.415999 0.528 2.16 0.528 3.76C0.528 4.016 0.56 4.272 0.624 4.496L2.432 4.624C2.368 4.448 2.336 4.144 2.336 3.904C2.336 2.992 2.96 2.08 4.144 2.08C5.312 2.08 5.872 2.864 5.872 3.696C5.872 4.24 5.648 4.704 5.12 5.088L4.384 5.616C3.456 6.288 3.088 7.072 3.088 8.032C3.088 8.256 3.104 8.432 3.12 8.64H4.72ZM2.768 10.944C2.768 11.584 3.28 12.112 3.936 12.112C4.576 12.112 5.104 11.584 5.104 10.944C5.104 10.304 4.576 9.76 3.936 9.76C3.28 9.76 2.768 10.304 2.768 10.944Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/_.822e4ffd.svg";
export { ForwardRef as ReactComponent };